import Datetime from "components/shared/datetime";
import { documentCreationStatuses, normalizeDocumentListParams } from "helpers/documentLists";
import moment from "moment";
import React from "react";

export const withDisabledTableControls = (columns) =>
    columns.map((column) => ({
        ...column,
        filterable: false,
        sortable: false,
    }));

export const DocumentListCounter = ({ count }) => (
    <>
        &nbsp;
        <small>
            (Всего: <strong>{count || 0}</strong>)
        </small>
    </>
);

export default function DocumentListFilters({ params, mergeParams }) {
    const listParams = normalizeDocumentListParams(params || {});

    const setPeriod = ({ name, value }) => {
        const defaultParams = normalizeDocumentListParams({});
        mergeParams({
            [name]: value ? moment(value).toISOString() : defaultParams[name],
            start: 0,
        });
    };

    const setDocumentCreationStatus = (event) => {
        mergeParams({
            documentCreationStatus: event.target.value,
            start: 0,
        });
    };

    return (
        <div className="container-fluid my-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-1 align-items-center">
                    <div className="mr-2 small">Период</div>
                    <div className="mr-2">
                        <Datetime
                            inPortal
                            inputProps={{ name: "startedAt", type: "datetime" }}
                            value={listParams.startedAt}
                            onChange={setPeriod}
                        />
                    </div>
                    <div className="mr-2">&mdash;</div>
                    <div className="mr-2">
                        <Datetime
                            inPortal
                            inputProps={{ name: "endedAt", type: "datetime" }}
                            value={listParams.endedAt}
                            onChange={setPeriod}
                        />
                    </div>
                </div>
                <div>
                    <select
                        className="form-control form-control-sm"
                        value={listParams.documentCreationStatus}
                        onChange={setDocumentCreationStatus}
                    >
                        {documentCreationStatuses.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
